/* **The app's save control — a 34×34 ember square with a floppy on it, and nothing else.**
 *
 * Transcribed from `Builder planu - tydzien - programator.dc.html`'s first row, where it is the only
 * save the plan builder draws. Promoted out of `pages/plan-builder/ui/BuilderTopBar.module.css` on
 * its second consumer, the survey editor's top bar (owner, 17 September 2026: the editor's save is
 * to be „dokładnie jak w builderze planów"). The builder reads this file now and its own rendering
 * did not change.
 *
 * It does NOT wear `emberButton.module.css`. That module draws the KANON specimen's FOUR shadows —
 * two inset lips on the border plus a two-part ember cast — and this mock draws two:
 * `inset 0 1px 0 rgba(255,255,255,.3), 0 5px 12px -4px rgba(196,58,10,.3)`, carried by
 * `--shadow-save`. The mock is the visual truth for both surfaces, so a third treatment for the
 * same act is the near-duplicate the styling rules exist to stop.
 *
 * The ember cast here is the owner's 2 September 2026 exception for a shared primary and nothing
 * new: `--shadow-save` was already this shadow, already shipped, and the glow ban still governs
 * every other surface. On 23 September 2026 the owner confirmed it and asked that it follow the
 * trainer's brand colour, which `entities/brand-color` does for `--shadow-save` too.
 *
 * ── The refused state is a grey square ─────────────────────────────────────────────────────
 * It kept the ember fill until 30 September 2026; the owner asked for a plainly greyed button. The
 * grey fill below and the reason an `aria-describedby` points at are what say a press will not act, and `aria-disabled` rather than the attribute is what keeps that reason in
 * the tab order.
 *
 * Every value is a token. Width and height are layout dimensions — see `stylelint.config.js`. */

.save {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;

  /* A `<button>` carries the user agent's `1px 6px`. The mock's element is a `<span>` at `0`, and
   * the glyph is centred by flex either way — this is the box measuring identically. */
  padding: var(--space-0);
  color: var(--on-accent-grad);
  cursor: pointer;
  background: var(--primary-fill);
  background-origin: border-box;
  border: 0;
  border-radius: var(--radius-11px);
  box-shadow: var(--shadow-primary-save);
}

/* `--text` rather than `--accent`: a focus ring must contrast against the control it surrounds, and
 * an accent ring on an accent fill is the one combination that disappears. */
.save:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* Nothing to save, or a save that cannot go yet: a plain grey square, and the ordinary arrow over it.
 * Owner, 30 September 2026 — the ember square under a `not-allowed` cursor read as a broken button;
 * a greyed one reads as "nothing to do". The reason still travels in `title` and `aria-describedby`. */
.save[aria-disabled="true"] {
  color: var(--text-3);
  cursor: default;
  background: var(--bg-chip);
  box-shadow: none;
}

/* The mock's 16×16 floppy, inside the 34px square. `SaveGlyph` defaults to this. */
.glyph {
  display: block;
  width: 16px;
  height: 16px;
}
